import React, { useState } from 'react';
import { Button, Card ,Table} from 'tabler-react';
import RemoveLastDirectoryPartOf from '../goBackButton';
import { useAPI } from '../../ApiCalls/useAPI';



export default class Appointment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            get: [],
            type: [],
            post: [],
            submit: ''
        };
        
    }

    getResponse(data) {
        // console.log(data);
        this.setState({
            get: data
        });
    }

    typeResponse(data) {
        this.setState({
            type: data
        });
    }


    componentDidMount() {
        const { getStudentDiary } = useAPI();
        getStudentDiary()
            .then((response) => this.getResponse(response))
            .catch((error) => console.error(error));
       
    }

    render() {
        const { get, type, post } = this.state;
         
        

        const SecondTab = () => {
            if (get === null || get.length === 0) {
                return (
                    <div className="SecondTab">
                        <div className="container">NO DATA FOUND</div>
                    </div>
                );
            }
            return (
                <div className="SecondTab">
                    <Card
                                   
                                    title='Disciplinary Action Record'
                                    body={
                                            <Table >
                                                <Table.Header>
                                                    <Table.Row>
                                                        <Table.ColHeader>
                                                         Date
                                                        </Table.ColHeader>
                                                        <Table.ColHeader >
                                                         Issue Description
                                                        </Table.ColHeader>
                                                        <Table.ColHeader >
                                                        Comments
                                                        </Table.ColHeader>                                                        
                                                    </Table.Row>
                                                </Table.Header>

                                                <Table.Body>
                               
                                                {get.reverse().map((complaint) => (
                                                        <Table.Row>
                                                        <Table.Col >
                                                            {complaint.date}                                                           
                                                        </Table.Col>
                                                        <Table.Col >
                                                            {complaint.description}                                                           
                                                        </Table.Col>
                                                        <Table.Col >
                                                            {complaint.counsellor_comments}                                                           
                                                        </Table.Col>                                                       

                                                    </Table.Row>
                                                ))}
                                            </Table.Body>
                                            </Table>
                                        }
                    />
                </div>
            );
        };

        

        return (
            <div className="container">
                <div
                    className="m-2 mt-4"
                    style={{ fontSize: '20px', display: 'flex' }}
                >
                    <div className="mr-4">
                        <a
                            href={RemoveLastDirectoryPartOf(
                                window.location.href
                            )}
                            style={{ textDecoration: 'none' }}
                        >
                            <i className="fe fe-arrow-left" />
                        </a>
                    </div>
                    <div>Student Diary</div>
                </div>
               <SecondTab/>
            </div>
        );
    }
}